// Torrelavega's two local holidays (San Roque, San Cipriano) are published in the BOC each year.
// Until a year's are published, the API sends them with `pendiente: true` (backend
// festivos_service.CONFIRMED_LOCAL_YEARS): they are the likely days and the ZBE counts them, but
// the pages must not present them as official.
export const PENDIENTE = 'pendiente de publicación';

/** The local festivos of a list that are not yet published. */
export function pendingLocals(festivos) {
  return (festivos || []).filter((f) => f && f.pendiente);
}
